export default {
    data: () => ({
        translations: {
            newCoupon: {
                el: "Δημιουργία Νέου Κωδικού",
                en: "Create New Code",
                it: "Crea una nuova password"
            },
            updateCoupon: {
                el: "",
                en: "Update Coupon With Code",
                it: ""
            },
            giftCategory: {
                el: "Κατηγορία Δώρου",
                en: "Gift Category",
                it: "Categoria di regalo"
            },
            couponCode: {
                el: "Κωδικός Κουπονιού (π.χ. Μαρούδας Οπτικά)",
                en: "Coupon Code (e.g. Maroudas Optika)",
                it: "Codice Coupon (es. Maroudas Optika)"
            },
            couponCodeHint: {
                el: "* Ο κωδικός τον οποίο μπορείτε να μοιραστείτε σε αφίσες, έντυπα και διαδίκτυο. Σας προτείνουμε να σχετίζεται με την επωνυμία σας.",
                en: `
                    * This is the code that you can share in posters, documents and internet. 
                    We suggest you to type something similar to your company name.
                `,
                it: "* Questo è il codice che puoi condividere in poster, documenti e internet. Ti suggeriamo di scrivere qualcosa di simile al nome della tua azienda."
            },
            moves: {
                el: "Moves (Πόντοι RoadCube)",
                en: "Moves (RoadCube Points)",
                it: "Moves (RoadCube Punti)"
            },
            totalCoupons: {
                el: "Σύνολο Κουπονιών",
                en: "Total Coupons",
                it: "Totale Coupon"
            },
            giftTitle: {
                el: "Όνομα Δώρου",
                en: "Gift Title",
                it: "Nome del regalo"
            },
            giftDescription: {
                el: "Περιγραφή Δώρου",
                en: "Gift Description",
                it: "Descrizione del regalo"
            },
            imageCheckbox: {
                el: "Θέλω το προϊόν να εμφανίζεται με εικόνα στην εφαρμογή",
                en:
                    "I want the product to be displayed with an image in the application",
                it: "Voglio che il prodotto sia visualizzato con un'immagine nell'app"
            },
            imageTitle: {
                el: "Εικόνα Προϊόντος (προαιρετικό)",
                en: "Product Image (optional)",
                it: "Immagine del prodotto (opzionale)"
            }
        }
    })
};
